import { render, staticRenderFns } from "./ContentReportsCard.vue?vue&type=template&id=3bfae602&scoped=true&"
import script from "./ContentReportsCard.vue?vue&type=script&lang=js&"
export * from "./ContentReportsCard.vue?vue&type=script&lang=js&"
import style0 from "./ContentReportsCard.vue?vue&type=style&index=0&id=3bfae602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfae602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VIcon})
